import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEmpresaSelecionada } from '../../util/empresaSelecionada';
import { getEmpresas } from '../../security/securityContext';
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada';
import habilitarAutenticacaoDoisFatores from '../../actions/usuario/habilitarAutenticacaoDoisFatores';
import recusaAutenticacaoDoisFatores from '../../actions/usuario/recusaAutenticacaoDoisFatores';

export class PainelMensagemAutenticacaoDoisFatores extends Component {
    
    getRedirecionaUsuario() {
        const empresas = getEmpresas();
        const empresaSelecionada = getEmpresaSelecionada();

        if (empresaSelecionada && empresaSelecionada.id) {
            this.props.history.push('/gestao-empresa')
            return;
        }
        if (empresas && empresas.length === 1) {
            this.props.alterarEmpresaSelecionada(empresas[0])
            this.props.history.push('/gestao-empresa')
            return;
        }
        if (empresas && empresas.length > 1 ) {
            this.props.history.push('/selecao-empresa')
        }
    }

    render() {
        return (<>
                <div className="painelMensagemAutenticacaoDoisFatores" style={{marginTop: '20px'}}>
                    <h2>🛡️ Proteja sua conta com a verificação em 2 fatores</h2>

                    <p>Olá,<br />
                        A segurança da sua conta é uma prioridade para nós. Por isso, o Sistema Vexado agora conta com verificação em 2 fatores (2FA) — uma camada extra de proteção que ajuda a evitar acessos não autorizados.
                    </p>
                    <p>
                        Ao ativar a 2FA, sempre que você fizer login, será solicitado um código de verificação enviado diretamente para seu e-mail. Assim, mesmo que alguém descubra sua senha, não conseguirá acessar sua conta sem esse código.
                    </p>

                    <p>✅ Vantagens da 2FA:</p>

                    <ul>
                        <li>Mais segurança para sua conta e dados.</li>
                        <li>Proteção contra acessos não autorizados.</li>
                        <li>Processo rápido e simples de ativar.</li>
                    </ul>

                    <p>
                        <button type="button" className="btn btn-success" onClick={() => {
                            this.props.habilitarAutenticacaoDoisFatores()
                                .then(() => {
                                    this.getRedirecionaUsuario();
                                });
                        }}>
                            Ativar agora a verificação em 2 fatores
                        </button>                    
                    </p>

                    <p>Recomendamos fortemente que todos os usuários ativem essa proteção para manter suas informações ainda mais seguras.</p>

                    <p>Atenciosamente, <br/>
                        Equipe de Segurança — Sistema Vexado.</p>

                    <p>
                        <button type="button" className="btn btn-danger" onClick={() => {
                            this.props.recusaAutenticacaoDoisFatores()
                                .then(() => {
                                    this.getRedirecionaUsuario();
                                })
                        }}>(Desconsiderar por enquanto)</button>
                    </p>
                </div>
        </>)
        
    }
}

export default withRouter(connect(null, {
    habilitarAutenticacaoDoisFatores,    
    alterarEmpresaSelecionada,
    recusaAutenticacaoDoisFatores
})(PainelMensagemAutenticacaoDoisFatores))